import React, { useState } from 'react';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';
import { ListItem, ListItemText, Collapse, List, ListItemIcon, Icon } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';

const CollapseItem = props => {
    const {
        text,
        subItems,
        classes,
        menuselectedsimple, // fix en torno al color #b98919
        submenuCollapseSelected,
        menuselectedcollapse,
        menuCollapseSelected,
        devices
    } = props;

    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(!open);
        menuCollapseSelected(text);
    };

    return (
        <div>
            <ListItem
                button
                onClick={handleClick}
                selected={false}
                className={(text === menuselectedsimple) ? classes.menuactive : classes.menudesactive}
            >
                {
                    props.svg ? (
                        <div className={classes.icon}>
                            {props.text === 'SOLPay' ? (
                                <img
                                    src={process.env.PUBLIC_URL + '/buttons/sol_pay_logo.png'}
                                    alt="Logo"
                                    style={{ width: isMobile ? '50%' : '75%' }}
                                />
                            ) : (
                                <Icon style={{ color: (text === menuselectedsimple ? "#2E2757" : "#abacb7") }}>
                                    {props.svgRoute}
                                </Icon>
                            )}
                        </div>
                    ) : (
                        <ListItemIcon>
                            <Icon>{props.svgRoute}</Icon>
                        </ListItemIcon>
                    )
                }

                <ListItemText
                    primary={
                        <Typography
                            component="span"
                            variant="body2"
                            className={classes.fontsize}
                        >
                            {text}
                        </Typography>
                    }
                    className={(text === menuselectedsimple) ? classes.listItemsactive : classes.listItems}
                />

                {open ? (
                    <ExpandLess style={{ color: "#000000" }} />
                ) : (
                    <ExpandMore style={{ color: "#000000" }} />
                )}
            </ListItem>

            <Collapse in={open} timeout="auto" unmountOnExit>
                <List
                    component="div"
                    disablePadding
                    style={{ display: "flex", flexDirection: "column", padding: "8px 0", gap: 8 }}
                >
                    {
                        subItems.map(subItem => {
                            const { text: subText, url, state } = subItem;
                            const { mac } = devices;

                            if (!state || (url === '/transfers-qr' && mac === 'NAVEGADOR')) return null;

                            return (
                                <ListItem
                                    key={subText}
                                    button={(isMobile) ? false : true}
                                    onClick={() => submenuCollapseSelected(url, subText, subText)}
                                    className={
                                        (subText === menuselectedcollapse || subText === menuselectedsimple)
                                            ? classes.listSubItemsactivebackground
                                            : classes.listSubItemsdesactivebackground
                                    }
                                >
                                    <ListItemText
                                        primary={
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                className={classes.fontsizeSubmenu}
                                            >
                                                {subText}
                                            </Typography>
                                        }
                                        className={
                                            (subText === menuselectedcollapse || subText === menuselectedsimple)
                                                ? classes.listSubItemsactive  // El color #b98919 AQUÍ
                                                : classes.listItemsdesactive
                                        }
                                    />
                                </ListItem>
                            );
                        })
                    }
                </List>
            </Collapse>
        </div>
    );
};

CollapseItem.propTypes = {
    icon: PropTypes.string,
    text: PropTypes.string.isRequired,
    subItems: PropTypes.array.isRequired,
    onSendData: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    menuselectedsimple: PropTypes.string.isRequired,
    submenuCollapseSelected: PropTypes.func.isRequired,
    menuselectedcollapse: PropTypes.string,
    menuCollapseSelected: PropTypes.func.isRequired,
    devices: PropTypes.object.isRequired
};

export default CollapseItem;
